var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "operation-modifier-confirm-modal",
        "destroy-on-hide": false,
        "aria-role": "dialog",
        "aria-label": "Atualizar CAP",
        "has-modal-card": "",
        "trap-focus": "",
        "on-cancel": _vm.close,
        "aria-modal": "",
      },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      _c("div", { staticClass: "modal-card", staticStyle: { width: "auto" } }, [
        _c("header", { staticClass: "modal-card-body" }, [
          _c("div", { staticClass: "modal-card-title modal-title" }, [
            _vm._v(" Atenção "),
          ]),
          _c("a", {
            staticClass: "close-modal delete",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ]),
        _c("section", { staticClass: "modal-card-body" }, [
          _c("p", [
            _vm._v(" O CAP será modificado com os seguintes valores. "),
          ]),
          _c("p", [
            _c("strong", [_vm._v("Parcela inicial:")]),
            _vm._v(" " + _vm._s(_vm.firstPayment) + " "),
            _c("br"),
            _c("strong", [_vm._v("Parcela final:")]),
            _vm._v(" " + _vm._s(_vm.lastPayment) + " "),
            _c("br"),
            _c("strong", [_vm._v("CAP:")]),
            _vm._v(
              " " + _vm._s(_vm.newInflationaryUpperBound.toFixed(2)) + "% "
            ),
          ]),
          _c("p", { staticClass: "text-align-center" }, [
            _vm._v(" Você tem certeza que quer continuar? "),
          ]),
          _c(
            "div",
            { staticClass: "buttons is-pulled-right" },
            [
              _c("b-button", {
                staticClass: "button is-button-secondary",
                attrs: {
                  id: "operation-modifier-modal-button-no",
                  label: "Não",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              }),
              _c("b-button", {
                staticClass: "button is-button-primary",
                attrs: {
                  id: "operation-modifier-modal-button-continue",
                  label: "Continuar",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.confirm()
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }